<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-number" id="pt1"><span><a href="#/toc#toc-part001">Part One</a></span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?25a5603c